import React, { useRef, useMemo } from 'react';
import moment from 'moment';
import { Calendar } from 'lucide-react';
import CircularProgressBar from '../../circular-progress';
import { isClient } from '../../../helpers/global';

const EtaClickableValue = ({ value, disabled, onDateChange, needsNewEta, loading }) => {
  const role = useMemo(() => localStorage.getItem('user-role'), []);

  const inputRef = useRef(null);

  const isValidValue = Boolean(value) && moment(value).isValid();

  const handleClick = () => {
    if (disabled) return;

    if (inputRef.current) {
      // Modern browsers (Chrome, Edge)
      if (inputRef.current.showPicker) {
        inputRef.current.showPicker();
      } else {
        inputRef.current.focus();
        inputRef.current.click();
      }
    }
  };

  if (isClient(role)) {
    return (
      <span className="font-weight-medium largeFont">
        {isValidValue ? moment(value).format('MMM Do, YYYY') : 'N/A'}
      </span>
    );
  }

  return (
    <div
      className="position-relative d-inline-flex align-items-center"
      style={{ cursor: !disabled && 'pointer', transition: 'opacity 0.2s' }}
      onClick={handleClick}
      onMouseEnter={e => {
        e.currentTarget.style.opacity = '0.7';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.opacity = '1';
      }}
    >
      <input
        ref={inputRef}
        type="date"
        disabled={disabled}
        value={isValidValue ? moment(value).format('YYYY-MM-DD') : ''}
        onChange={e => {
          const v = e.target.value;
          onDateChange(v === '' ? null : v);
        }}
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none'
        }}
        tabIndex={-1}
        aria-hidden="true"
      />

      <span className={`font-weight-medium largeFont mb-0 d-flex align-items-center ${disabled ? 'text-muted' : ''}`}>
        <span style={{ color: needsNewEta ? '#dfd633' : 'inherit' }}>
          {isValidValue ? moment(value).format('MMM Do, YYYY') : 'N/A'}
        </span>
        {loading ? (
          <CircularProgressBar size={1} className="ml-2 text-muted" />
        ) : (
          <Calendar disabled={disabled} size={14} className="ml-2 text-info" />
        )}
      </span>
    </div>
  );
};

export default EtaClickableValue;
